export default __webpack_public_path__ + "static/media/logo_white.fb5f44f1.jpg";